'use client'

import { type LucideIcon } from 'lucide-react'
import { useRouter } from '@/routes/hooks/use-router'
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from '@/components/ui/sidebar'
import {
  Package,
  ShoppingCart,
  FileText,
  Store,
  Calendar,
  ViewIcon,
  BanknoteArrowDownIcon,
  Settings,
  LayoutDashboard,
  VerifiedIcon,
  Rss,
  Gift,
  Swords,
  MapPin,
  ArrowLeftRight,
  Music,
  Video,
  Layers,
} from 'lucide-react'

type NavMenuEntry =
  | {
      title: string
      path: string
      icon: string
    }
  | {
      type: 'divider'
    }

// Icon mapping สำหรับเมนู
const iconMap: Record<string, LucideIcon> = {
  Package,
  ShoppingCart,
  FileText,
  Store,
  Calendar,
  ViewIcon,
  BanknoteArrowDownIcon,
  Settings,
  LayoutDashboard,
  VerifiedIcon,
  Rss,
  Gift,
  Swords,
  MapPin,
  ArrowLeftRight,
  Music,
  Video,
  Layers,
}

export function NavMain({
  groups,
}: {
  groups: {
    label: string
    items: NavMenuEntry[]
  }[]
}) {
  const router = useRouter()

  return (
    <>
      {groups.map((group) => (
        <SidebarGroup key={group.label}>
          <SidebarGroupLabel>{group.label}</SidebarGroupLabel>
          <SidebarMenu>
            {group.items.map((item, index) => {
              if ('type' in item && item.type === 'divider') {
                return (
                  <SidebarMenuItem
                    key={`${group.label}-divider-${index}`}
                    className="py-1 group-data-[collapsible=icon]:hidden"
                  >
                    <SidebarSeparator className="mx-0" />
                  </SidebarMenuItem>
                )
              }

              return (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <a
                      onClick={() => router.push(item.path)}
                      className="cursor-pointer"
                    >
                      {item.icon &&
                        iconMap[item.icon] &&
                        (() => {
                          const IconComponent = iconMap[item.icon]
                          return <IconComponent />
                        })()}
                      <span>{item.title}</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              )
            })}
          </SidebarMenu>
        </SidebarGroup>
      ))}
    </>
  )
}
